import { Button } from "antd";
import React from "react";
import styled from "styled-components";

const ThreeBanners = () => {
  return (
    <Container>
      <MainContainer>
        <MainImage src="/webImg/main-img.jpg" />
        <SubContainer>
          <SubBox>
            <SubImage src="https://i.ibb.co/7xktN3Td/thumbnail-image0.png" />
            <DetailBox>
              <TitleSubBox>
                SU Bible Day Camp #10 พลัง 1-2เปโตร “ยืนหยัดทำสิ่งถูกต้อง”
              </TitleSubBox>
              <div style={{ display: "flex", gap: "10px" }}>
                <a
                  rel="noreferrer"
                  style={{ flex: 1 }}
                  target="_blank"
                  href="https://forms.gle/vM9vVNYUAXAWzq8n7"
                >
                  <Button
                    type="primary"
                    style={{ width: "100%" }}
                    shape="round"
                  >
                    <div>สมัครเลย</div>
                  </Button>
                </a>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://www.su-thailand.org/activities?actNo=11"
                >
                  <Button
                    type="primary"
                    style={{
                      flex: 1,
                      background: "white",
                      color: "#1976FD",
                      border: "1px solid #1976FD",
                    }}
                    shape="round"
                  >
                    <div>รายละเอียด</div>
                  </Button>
                </a>
              </div>
            </DetailBox>
          </SubBox>
          <SubBox>
            <SubImage src="https://i.ibb.co/hx1g0ZQ2/third-banner.jpg" />
            <DetailBox>
              <TitleSubBox>
                “เตรียมให้พร้อม” สำหรับการเดินทางของคุณไปสู่อาณาจักรของพระเจ้า
              </TitleSubBox>
              <div style={{ display: "flex", gap: "10px" }}>
                <a
                  rel="noreferrer"
                  style={{ flex: 1 }}
                  target="_blank"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSelmWKbWXF6zSu9Aw9l8W6EoSN3glvikbQhSYq5lf0QyoirpA/closedform"
                >
                  <Button
                    type="primary"
                    style={{ width: "100%" }}
                    shape="round"
                  >
                    <div>สั่งซื้อเลย</div>
                  </Button>
                </a>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSelmWKbWXF6zSu9Aw9l8W6EoSN3glvikbQhSYq5lf0QyoirpA/closedform"
                >
                  <Button
                    type="primary"
                    style={{
                      flex: 1,
                      background: "white",
                      color: "#1976FD",
                      border: "1px solid #1976FD",
                    }}
                    shape="round"
                  >
                    <div>รายละเอียด</div>
                  </Button>
                </a>
              </div>
            </DetailBox>
          </SubBox>
        </SubContainer>
      </MainContainer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  margin-top: 20px;
  padding: 20px;
  display: flex;
  justify-content: center;
  @media (max-width: 600px) {
    padding: 20px;
  }
`;

const MainContainer = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  max-width: 1100px;
  flex-wrap: wrap;
`;

const MainImage = styled.img`
  border-radius: 8px;
  max-width: 600px;
  width: 100%;
`;

const SubImage = styled.img`
  border-radius: 8px;
  max-width: 140px;
  width: auto;
`;

const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
`;

const SubBox = styled.div`
  width: 100%;
  background: black;
  flex: 1;
  display: flex;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  background-image: linear-gradient(to top, #046aaf 0%, #04befe 100%);
  gap: 10px;

  @media (max-width: 600px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

const DetailBox = styled.div`
  background: white;
  border-radius: 8px;
  padding: 8px;
  width: 100%;
  /* height: 100%; */
  display: flex;
  gap: 20px;
  flex-direction: column;
  justify-content: space-between;
  align-items: space-between;
`;

const TitleSubBox = styled.div`
  font-size: 16px;
`;

export default ThreeBanners;
